import React, { useState, useEffect, useCallback } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, FormControl, FormLabel, Textarea,
  Box, Text, Switch, useToast, Flex, Badge,
} from '@chakra-ui/react';
import api from '../api';

export default function AutoContactsModal({ isOpen, onClose }) {
  const [settings, setSettings] = useState([]);
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  const fetchSettings = useCallback(async () => {
    try { const { data } = await api.get('/lookups/auto-contact-settings'); setSettings(data); } catch(e) {}
  }, []);

  useEffect(() => { if (isOpen) fetchSettings(); }, [isOpen, fetchSettings]);

  const getBirthday = () => settings.find(s => s.setting_key === 'birthday_wishes') || {};

  const handleToggle = async (enabled) => {
    setSaving(true);
    try {
      await api.put('/lookups/auto-contact-settings/birthday_wishes', { is_enabled: enabled });
      await fetchSettings();
      toast({ title: enabled ? 'Birthday wishes enabled' : 'Birthday wishes disabled', status: 'success', duration: 1500 });
    } catch(e) { toast({ title: 'Failed', status: 'error', duration: 2000 }); }
    finally { setSaving(false); }
  };

  const handleSaveTemplate = async () => {
    const bd = getBirthday();
    setSaving(true);
    try {
      await api.put('/lookups/auto-contact-settings/birthday_wishes', { setting_value: bd.setting_value });
      toast({ title: 'Template saved', status: 'success', duration: 1500 });
    } catch(e) { toast({ title: 'Failed', status: 'error', duration: 2000 }); }
    finally { setSaving(false); }
  };

  const updateTemplate = (val) => {
    setSettings(prev => prev.map(s =>
      s.setting_key === 'birthday_wishes' ? { ...s, setting_value: val } : s
    ));
  };

  const bd = getBirthday();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay /><ModalContent>
        <ModalHeader fontSize="md">Auto Contacts</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Box p={4} border="1px" borderColor="gray.200" borderRadius="md">
              <Flex justify="space-between" align="center" mb={3}>
                <Box>
                  <Text fontSize="13px" fontWeight="600">Send Birthday Wishes</Text>
                  <Text fontSize="10px" color="gray.500">
                    Automatically emails contacts on their birthday at 8am.
                    Only contacts with "Wish happy birthday" enabled will receive emails.
                  </Text>
                </Box>
                <Switch size="lg" colorScheme="green" isChecked={!!bd.is_enabled}
                  onChange={(e) => handleToggle(e.target.checked)} />
              </Flex>

              <Badge fontSize="8px" colorScheme={bd.is_enabled ? 'green' : 'gray'} mb={3}>
                {bd.is_enabled ? 'Active' : 'Inactive'}
              </Badge>

              <FormControl>
                <FormLabel fontSize="xs" mb={1}>
                  Email Template
                  <Text as="span" color="blue.500" fontSize="10px" ml={2}>
                    Use {'{NAME}'} for the contact's name
                  </Text>
                </FormLabel>
                <Textarea size="sm" rows={6} value={bd.setting_value || ''}
                  onChange={(e) => updateTemplate(e.target.value)}
                  placeholder={'Dear {NAME},\n\nHappy Birthday!\n\nWarm regards,\nThe Team'} />
              </FormControl>

              <Flex justify="flex-end" mt={2}>
                <Button size="xs" bg="brand.600" color="white" _hover={{ bg: 'brand.700' }}
                  onClick={handleSaveTemplate} isLoading={saving}>Save Template</Button>
              </Flex>

              <Box mt={3} p={2} bg="gray.50" borderRadius="md">
                <Text fontSize="9px" fontWeight="600" color="gray.500" mb={1}>PREVIEW</Text>
                <Text fontSize="11px" whiteSpace="pre-wrap">
                  {(bd.setting_value || '').replace(/\{NAME\}/g, 'John Smith')}
                </Text>
              </Box>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter><Button size="sm" onClick={onClose}>Close</Button></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
